<template>
  <div>
    <div class="block__container block__container--compact">
      <step-header-component :headerText="headerText" :subHeaderText="subHeaderText"></step-header-component>
      <pricing-data :isLast="false"></pricing-data>
      <blurred-pricing-curve></blurred-pricing-curve>
      <benefits-list></benefits-list>
      <previous-manufacturer :validationScope="validationScope"></previous-manufacturer>
      <purchase-time :validationScope="validationScope"></purchase-time>
      <vehicle-change-frequency :validationScope="validationScope"></vehicle-change-frequency>
      <next-button :validationScope="validationScope" :buttonText="buttonText" :isLast="true"></next-button>
    </div>
  </div>
</template>

<script lang="ts">
import {
  Component, Prop, Vue, Watch
} from 'vue-property-decorator';
import StepHeaderComponent from '../general/StepHeaderComponent.vue';
import NextButtonComponent from '../navigation/NextButtonComponent.vue';
import PricingDataComponent from '../pricing/PricingDataComponent.vue';
import BlurredPricingCurveComponent from '../pricing/BlurredPricingCurveComponent.vue';
import BlurredPricingCurveBenefitsComponent from '../pricing/BlurredPricingCurveBenefitsComponent.vue';
import PreviousManufacturerDetailsComponent from '../enquiry/PreviousManufacturerDetailsComponent.vue';
import PurchaseTimeComponent from '../finance/PurchaseTimeComponent.vue';
import VehicleChangeFrequencyComponent from '../finance/VehicleChangeFrequencyComponent.vue';

@Component({
  components: {
  'step-header-component': StepHeaderComponent,
  'next-button': NextButtonComponent,
  'pricing-data': PricingDataComponent,
  'blurred-pricing-curve': BlurredPricingCurveComponent,
  'benefits-list': BlurredPricingCurveBenefitsComponent,
  'previous-manufacturer': PreviousManufacturerDetailsComponent,
  'purchase-time': PurchaseTimeComponent,
  'vehicle-change-frequency': VehicleChangeFrequencyComponent
  }
  })

export default class VehicleChangeFrequencyStepComponent extends Vue {
  @Prop({ default: 'Market Trends' })
  public headerText!: string;

  @Prop({ default: 'See current pricing trends for the new vehicleName' })
  public subHeaderText!: string;

  private buttonText: string = 'Almost there';

  @Prop({ default: null })
  public validationScope!: string;
}
</script>
